<template>
  <div class="notices">
    <div style="margin-bottom: 10px;">
      <el-text style="font-size: larger; font-weight: bolder;">平台信息</el-text>
    </div>
    <el-form :inline="true">
      <el-form-item :label="util.language('平台名称', '')">
        <el-input style="width: 120px;" v-model="searchParam.titleLike" clearable />
      </el-form-item>
      <el-form-item :label="util.language('备注', '')">
        <el-input style="width: 120px;" v-model="searchParam.contentLike" clearable />
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="commitFindList()" :loading="loading.find">搜索</el-button>
          <el-button @click="resetSearchParam()">{{ util.language('重置', 'Reset') }}</el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="add()">新增</el-button>
          <el-button type="warning" :disabled="show.selected.length != 1" @click="update()">详情</el-button>
          <el-button type="danger" :disabled="show.selected.length < 1" @click="del()">删除</el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table :data="data.noticeList" @selection-change="selectionChange()" ref="tabRef" border style="height: calc(100vh - 220px);" v-loading="loading.find">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="系统编号" width="170" align="center">
        <template #default="scope">
          <el-link type="primary" @click="update(scope.row)">{{ scope.row.kkey }}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="信息">
        <template #default="scope">
          <div style="display: flex;">
            <div style="width: 70px; height: 70px; background-color: antiquewhite;">
              <el-image style="width: 100%; height: 100%;" :src="scope.row.headerFile" fit="cover" />
            </div>
            <div style="margin-left: 10px;">
              <el-text>{{ scope.row.title }}</el-text>
              <br />
              <el-link type="primary" @click="util.clipBoard('https://www.youtugz.com/' + scope.row.kkey + '/#/')">{{ 'https://www.youtugz.com/' + scope.row.kkey + '/#/' }}</el-link>
              <br />
              <el-text>备注：</el-text>
              <el-text>{{ scope.row.content || '-' }}</el-text>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div style="height: 10px;" />
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import api from '../../apis/api'
import apiNative from '../../apis/apiNative'
import cache from '../../utils/cache'
import util from '../../utils/util'
import math from '../../utils/math'

const router = useRouter()
const tabRef = ref()

const loading = reactive({
  find: false,
})
const data = reactive({
  noticeList: [],
})

const show = reactive({
  selected: [],
})

const searchParam = reactive({})
const resetSearchParam = () => {
  searchParam.type = 'SYSTEM'
  searchParam.titleLike = ''
  searchParam.contentLike = ''
}
resetSearchParam()

const commitFindList = () => {
  console.log(searchParam)
  api.get('/backend/notice/getNoticeList', { params: searchParam }).then(res => {
    data.noticeList = res.list
    for (const notice of data.noticeList) {
      const files = util.json2Elfile(notice.file)
      if (files.length > 0) {
        notice.headerFile = files[0].url
      } else {
        notice.headerFile = ''
      }
    }
  }).finally(() => {
    loading.find = false
  })
}
commitFindList()

const selectionChange = () => {
  show.selected = tabRef.value.getSelectionRows()
}

const add = () => {
  cache.setObject(cache.keys.pageParam + 'system', null)
  router.push('/system')
}

const del = () => {
  const notices = tabRef.value.getSelectionRows()
  const noticeIdList = notices.map(notice => notice.id)
  ElMessageBox.confirm('', {
    title: '确认删除',
    message: '将要删除选中的项？',
    autofocus: false,
    confirmButtonText: '删除',
    cancelButtonText: '取消',
  }).then(() => {
    api.post('/backend/notice/delNotice', { ids: noticeIdList }).then(() => {
      ElMessage.success('删除成功')
      commitFindList()
    })
  })
}

const update = (row) => {
  const notice = row ? row : tabRef.value.getSelectionRows()[0]
  cache.setObject(cache.keys.pageParam + 'system', notice)
  router.push('/system')
}
</script>

<style lang="less"></style>